import $ from 'jquery';
import lozad from 'C:\\Program Files (x86)\\Microsoft VS Code\\bin\\node_modules\\lozad';


$(() => {
    // lazy loads elements with default selector as '.lozad'
    const observer = lozad('.lozad', {
        loaded(el) {
            el.classList.add('loaded');
            if ($(el).closest('.slick-track').length) {
                $(el).on('load', () => {
                    const slideHeight = $(el).closest('.has-link').height();
                    const trackHeight = $(el).closest('.slick-track').height();
                    if (slideHeight > trackHeight) {
                        $(el).closest('.slick-track').height(slideHeight);
                    }
                });
            }
        },
    });
    observer.observe();
});
